import './Frontend.css';
import VerticalStepper from '../UI/VerticalStepper';
import { useEffect, useState } from 'react';
import HomeNavbar from '../UI/HomeNavbar';
import { useUserAuth } from '../../context/UserAuthContext';
import LoadingModal from '../UI/LoadingModal';
import ErrorModal from '../UI/ErrorModal';

const GameDev = ({saveProgressData, getProgressData}) => {
    const IntroSteps = [
        {
            label: 'Understanding Game Development',
            description: `Explore the basics of game development concepts and terminology.`,
            link: 'https://pll.harvard.edu/course/cs50s-introduction-game-development'
        },
        {
            label: 'Overview of Unity Engine',
            description: `Learn about Unity's interface, features, and capabilities.`,
            link: 'https://www.freecodecamp.org/news/unity-game-engine-guide-how-to-get-started-with-the-most-popular-game-engine-out-there/'
        },
        {
            label: 'Getting Started with C#',
            description: `Start with C#, the scripting language used in Unity game development.`,
            link: 'https://www.youtube.com/watch?v=gfkTfcpWqAY'
        }
    ];

    const GameAssetSteps = [
        {
            label: '2D and 3D Art Fundamentals',
            description: `Master the basics of creating art assets for games.`,
            link: 'https://www.youtube.com/watch?v=YctaKp9G-Fo'
        },
        {
            label: 'Animation Techniques',
            description: `Learn animation principles and how to create dynamic movements.`,
            link: 'https://meliorgames.com/game-art-design/the-key-principles-of-animation-in-video-games/'
        },
        {
            label: 'Sound and Music Integration',
            description: `Understand audio integration for immersive gameplay experiences.`,
            link: 'https://www.youtube.com/watch?v=5jYSmq9Xqb0'
        }
    ];

    const GameMechSteps = [
        {
            label: 'Physics and Collision Detection',
            description: `Implement physics and collision mechanics for realistic interactions.`,
            link: 'https://www.youtube.com/watch?v=3lBYVSplAuo'
        },
        {
            label: 'User Interface (UI) Design',
            description: `Design user interfaces for menus, HUDs, and game interactions.`,
            link: 'https://www.youtube.com/watch?v=125U897rRB0'
        },
        {
            label: 'Game Design Principles',
            description: `Explore gameplay mechanics, level design, and player engagement.`,
            link: 'https://www.youtube.com/watch?v=QDldZWvNK_E'
        }
    ];

    const GameProgSteps = [
        {
            label: 'Player Input and Controls',
            description: `Implement controls and manage player input for seamless gameplay.`,
            link: 'https://www.youtube.com/watch?v=5tOOstXaIKE'
        },
        {
            label: 'Creating Gameplay Systems',
            description: `Build core gameplay systems such as health, scoring, and timers.`,
            link: 'https://www.youtube.com/watch?v=K0F14bQEEos'
        },
        {
            label: 'AI and Pathfinding',
            description: `Integrate AI behaviors and navigation in your game.`,
            link: 'https://learn.unity.com/project/beginner-ai-pathfinding'
        }
    ];

    const GameOptimizeSteps = [
        {
            label: 'Optimizing Performance',
            description: `Optimize your game for smooth performance and efficient resource usage.`,
            link: 'https://www.youtube.com/watch?v=ysk7ATmIeOs'
        },
        {
            label: 'Visual Effects and Particles',
            description: `Add visual effects and particle systems to enhance your game's visuals.`,
            link: 'https://www.youtube.com/watch?v=pNYZZk5h3lM'
        },
        {
            label: 'Testing and Debugging',
            description: `Learn testing techniques and debugging tools for error-free gameplay.`,
            link: 'https://docs.unity3d.com/Manual/ManagedCodeDebugging.html'
        }
    ];

    const GamePublishSteps = [
        {
            label: 'Build and Export Your Game',
            description: `Prepare your game for deployment on various platforms.`,
            link: 'https://www.youtube.com/watch?v=7nxKAtxGSn8'
        },
        {
            label: 'Monetization Strategies',
            description: `Explore ways to monetize your game through ads, in-app purchases, and more.`,
            link: 'https://docs.unity.com/ads/en-us/manual/MonetizationStrategy'
        },
        {
            label: 'Publishing on Different Platforms',
            description: `Distribute your game to PC, console, mobile, and VR platforms.`,
            link: 'https://blog.unity.com/games/the-good-the-gory-and-the-glory-of-publishing-your-game-to-multiple-platforms-including'
        }
    ];

    // Totol Steps = 18

    // The total Progress is for progress graph for every user whereas individual step progress is for saving the progress in DB
    const [totalCompletedSteps, setTotalCompletedSteps] = useState(0);

    // Introduction to ML Progress
    const [introCompletedSteps, setIntroCompletedSteps] = useState(0);

    const handleIntroStepComplete = () => {
        setIntroCompletedSteps(introCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
        console.log(introCompletedSteps);
    };

    const handleIntroStepBack = () => {
        setIntroCompletedSteps(introCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Game Assets Progress
    const [gameAssetCompletedSteps, setGameAssetCompletedSteps] = useState(0);

    const handleGameAssetStepComplete = () => {
        setGameAssetCompletedSteps(gameAssetCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleGameAssetStepBack = () => {
        setGameAssetCompletedSteps(gameAssetCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Game Mechanics Progress
    const [gameMechCompletedSteps, setGameMechCompletedSteps] = useState(0);

    const handleGameMechStepComplete = () => {
        setGameMechCompletedSteps(gameMechCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleGameMechStepBack = () => {
        setGameMechCompletedSteps(gameMechCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Programming Game Logic Progress
    const [gameProgCompletedSteps, setGameProgCompletedSteps] = useState(0);

    const handleGameProgStepComplete = () => {
        setGameProgCompletedSteps(gameProgCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleGameProgStepBack = () => {
        setGameProgCompletedSteps(gameProgCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Game Optimization Progress
    const [gameOptimizeCompletedSteps, setGameOptimizeCompletedSteps] = useState(0);

    const handleGameOptimizeStepComplete = () => {
        setGameOptimizeCompletedSteps(gameOptimizeCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleGameOptimizeStepBack = () => {
        setGameOptimizeCompletedSteps(gameOptimizeCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Game Publishing Progress
    const [gamePublishCompletedSteps, setGamePublishCompletedSteps] = useState(0);

    const handleGamePublishStepComplete = () => {
        setGamePublishCompletedSteps(gamePublishCompletedSteps + 1);
        setTotalCompletedSteps(totalCompletedSteps + 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    const handleGamePublishStepBack = () => {
        setGamePublishCompletedSteps(gamePublishCompletedSteps - 1);
        setTotalCompletedSteps(totalCompletedSteps - 1);
        console.log(`Total Steps - ${totalCompletedSteps}`);
    };

    //Firestore data
    useEffect(() =>{
        saveProgressData({
            totalSteps: 18,
            totalCompletedSteps: totalCompletedSteps,
            introCompletedSteps: introCompletedSteps,
            gameAssetCompletedSteps: gameAssetCompletedSteps,
            gameMechCompletedSteps: gameMechCompletedSteps,
            gameProgCompletedSteps: gameProgCompletedSteps,
            gameOptimizeCompletedSteps: gameOptimizeCompletedSteps,
            gamePublishCompletedSteps: gamePublishCompletedSteps,
        });
    }, [totalCompletedSteps, introCompletedSteps, gameAssetCompletedSteps, gameMechCompletedSteps, gameProgCompletedSteps, gameOptimizeCompletedSteps, gamePublishCompletedSteps]);

    const {currentUser, isLoading} = useUserAuth();
    const [error, setError] = useState('');

    useEffect(() => {
        const asyncFunc = async() => {
            const progressData = await getProgressData();
            console.log(progressData);
            if (progressData) {
                setTotalCompletedSteps(progressData.totalCompletedSteps);
                setIntroCompletedSteps(progressData.introCompletedSteps);
                setGameAssetCompletedSteps(progressData.gameAssetCompletedSteps);
                setGameMechCompletedSteps(progressData.gameMechCompletedSteps);
                setGameProgCompletedSteps(progressData.gameProgCompletedSteps);
                setGameOptimizeCompletedSteps(progressData.gameOptimizeCompletedSteps);
                setGamePublishCompletedSteps(progressData.gamePublishCompletedSteps);
            }
        };
        asyncFunc();
        if(!currentUser && !isLoading){
            setError('Error');
        }
        else{
            setError('');
        }
    }, [currentUser]);


    return (
        <body>
            <HomeNavbar/>
            <h1 className='tech-main-title'>Game Development</h1>
            <div className='web-container'>
                <div className='html-container'>
                    <h1 className='tech-title'>Introduction to Game Development</h1>
                    <VerticalStepper steps={IntroSteps} onStepComplete={handleIntroStepComplete} onStepBack={handleIntroStepBack} stepsCompleted={introCompletedSteps}/>
                </div>
                <div className='js-container'>
                    <h1 className='tech-title'>Creating Game Assets</h1>
                    <VerticalStepper steps={GameAssetSteps} onStepComplete={handleGameAssetStepComplete} onStepBack={handleGameAssetStepBack} stepsCompleted={gameAssetCompletedSteps}/>
                </div>
                <div className='react-container'>
                    <h1 className='tech-title'>Game Mechanics and Design</h1>
                    <VerticalStepper steps={GameMechSteps} onStepComplete={handleGameMechStepComplete} onStepBack={handleGameMechStepBack} stepsCompleted={gameMechCompletedSteps}/>
                </div>
                <div className='api-container'>
                    <h1 className='tech-title'>Programming Game Logic</h1>
                    <VerticalStepper steps={GameProgSteps} onStepComplete={handleGameProgStepComplete} onStepBack={handleGameProgStepBack} stepsCompleted={gameProgCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Polishing and Optimization</h1>
                    <VerticalStepper steps={GameOptimizeSteps} onStepComplete={handleGameOptimizeStepComplete} onStepBack={handleGameOptimizeStepBack} stepsCompleted={gameOptimizeCompletedSteps}/>
                </div>
                <div className='git-container'>
                    <h1 className='tech-title'>Publishing and Distribution</h1>
                    <VerticalStepper steps={GamePublishSteps} onStepComplete={handleGamePublishStepComplete} onStepBack={handleGamePublishStepBack} stepsCompleted={gamePublishCompletedSteps}/>
                </div>
            </div>
            <ErrorModal errorMsg='Plz Login To Save Your Progress!' isError={error} />
            <LoadingModal isLoading={isLoading} msg={'Loading..'}/>
        </body>
    );
}

export default GameDev;